import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const KfzFormSkeleton = () => <MultipleInputSkeleton count={8} />

export default memo(KfzFormSkeleton)
